<template>
  <div class="img-news-card">
    <div class="img-box" @click="handleClick">
      <img :src="news.newsImg" :width="imgStyle.width" :height="imgStyle.height" alt="" class="card-image" />
    </div>
    <p class="card-title" @click="handleClick">{{ news.newsTitle }}</p>
    <p class="card-desc" v-if="news.newsSubcontent && news.newsSubcontent !== news.newsTitle">{{ news.newsSubcontent }}</p>
  </div>
</template>

<script>
export default {
  name: "ImgNewsCard",
  props: {
    imgStyle: {
      type: Object,
      default: () => {
        return {
          width: "200px",
          height: "100px"
        }
      },
    },
    news: {
      type: Object,
      default: () => {
        return {
          title: "",
          newsImg: "",
          desc: ""
        }
      },
    },
  },
  methods: {
    handleClick() {
      this.$router.push({
        path: `/index/info/${this.news.id}`,
        query: {
          linkMenuId: this.news?.newsMenuId || ""
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.img-news-card {
  width: 200px;
  border-radius: 4px;
  background: #F5F5F5;
  text-align: center;
}

.card-image {
  cursor: pointer;
  object-fit: cover;
}

.card-title {
  cursor: pointer;
  color: #626466;
  text-decoration: none;
  font-size: 14px;
  line-height: 40px;
  text-align: left;
  background: url("../assets/images/caseline.jpg") bottom left no-repeat;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #505050;
  &:hover {
    color: #fdc202;
  }
}

.card-desc {
  font-size: 12px;
  text-align: left;
  padding-left: 0px;
  padding-top: 5px;
  color: #505050;
  word-break: break-word;
  white-space: normal;
  display: block;
  display: -webkit-box;
  max-height: calc(21px * 4); /* 行高 × 最大行数 */
  line-height: 20px;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>